<template>
  <div>
    <pvd-modal id="modal-container" ref="modalContainer" pvd-z-index="9999999" pvd-aria-label="guided-search-modal">
      <amount-content
        v-if="showAmountContent"
        id="amount-modal"
        ref="amountModal"
        :amountValue="amountValue"
        :amountInvalid="amountInvalid"
        :amountMaxExceeded="amountMaxExceeded"
        @amountChanged="amountChanged($event)"
        @closeAmountModal="switchContent()"></amount-content>
      <duration-content
        v-if="showDurationContent"
        id="duration-modal"
        :sliderIndex="currentIndex"
        @closeDurationModal="closeDurationModal()"
        @backButtonClicked="backButtonClicked()"
        @durationChanged="sliderChanged($event)"></duration-content>
    </pvd-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';
import { PvdModal } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import { ClientConstants } from './../client.constants';
import { Utils } from './../utils/Utils';
import AmountContent from './AmountContent.vue';
import DurationContent from './DurationContent.vue';

export default defineComponent({
  name: 'InputModal',
  components: { AmountContent, DurationContent },
  props: {
    sliderIndex: { type: Number, default: 1 }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      showAmountContent: true,
      showDurationContent: false,
      amountValue: '',
      currentIndex: 0,
      amountInvalid: false,
      amountMaxExceeded: false
    };
  },
  methods: {
    resetAmount() {
      if (this.$refs['amountModal']) {
        (this.$refs['amountModal'] as typeof AmountContent).clearAmount();
      }
    },
    openModal() {
      this.showAmountContent = true;
      this.showDurationContent = false;
      this.amountValue = '';
      this.resetAmount();
      this.currentIndex = this.sliderIndex;
      this.amountInvalid = false;
      this.amountMaxExceeded = false;
      (this.$refs['modalContainer'] as PvdModal).pvdOpen = true;
    },
    backButtonClicked() {
      this.showAmountContent = true;
      this.showDurationContent = false;
    },
    amountChanged(value: string) {
      this.amountValue = value;
      const numericAmount = Utils.formatNumber(this.amountValue);
      this.amountInvalid = numericAmount < 100 || numericAmount % 100 != 0;
      this.amountMaxExceeded = numericAmount > 9999900;
    },
    switchContent() {
      this.showAmountContent = false;
      this.showDurationContent = true;
    },
    sliderChanged(event: Event) {
      this.currentIndex = Number((event.target as HTMLInputElement).value);
    },
    closeDurationModal() {
      this.showAmountContent = false;
      this.showDurationContent = false;
      (this.$refs['modalContainer'] as PvdModal).pvdOpen = false;
      const event = { amount: this.amountValue, index: this.currentIndex };
      this.$emit('modalClosed', event);
    }
  }
});
</script>
